export default class Question {

    constructor(id, media, order, translations){
        this.id = id;
        this.media = media;
        this.order = order;
        this.translations = translations;
    }

    getId(){
        return this.id;
    }

    getMedia(){
        return this.media;
    }

    getOrder(){
        return this.order;
    }

    getTranslations(){
        return this.translations;
    }

    setId(id){
        this.id = id;
    }

    setMedia(media){
        this.media = media;
    }

    setOrder(order){
        this.order = order;
    }

    setTranslations(translations){
        this.translations = translations;
    }
}